module.exports = require("split.js");